"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgViewLanguage = void 0;
class MsgViewLanguage {
    constructor(init) {
        Object.assign(this, init);
    }
}
exports.MsgViewLanguage = MsgViewLanguage;
